import MTemplate from "../../modules/MTemplate";
import MDiaryDayEntry from "./MDiaryDayEntry";

export default class MDiaryDaySection
{
	constructor(el)
	{
		this.el = el;
	}

	getEntries()
	{
		let entries = [];
		this.el.querySelectorAll('.profile-entry').forEach(el => {
			entries.push(new MDiaryDayEntry(el));
		});

		return entries;
	}

	getPreloderTemplate()
	{
		return new MTemplate(this.el.querySelector('.preloader-template'));
	}

	setEntriesHtml = function(template) {
		this.el.querySelector('.profile-entries').innerHTML = template;
	}

	hide()
	{
		this.el.setAttribute('hidden', '');
		this.el.classList.add('hidden');
	}

	show()
	{
		this.el.removeAttribute('hidden');
		this.el.classList.remove('hidden');
	}
}
